import axios from 'axios';
import React from 'react'
import Footer from '../Footer/Footer';
import Header from '../Header/Header';

const ExpressInterest = () => {
  const api = process.env.REACT_APP_API_URL as string;

    const handleExpressSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
  event.preventDefault();

  // Example form data collection
  const formData = new FormData(event.currentTarget);
  const data = {
    fullName: formData.get('fullName'),
    email: formData.get('email'),
    dob: formData.get('dob'),
    businessName: formData.get('businessName'),
    category: formData.get('category'),
    mobile: formData.get('mobile'),
  };

  // console.log('data of express',data);

  try {
    const response = await axios.post(`${api}/auth/express-interest`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    if (response.status === 200 || response.status === 201) {
      // console.log('Express Interest form submitted successfully');
    } else {
      console.error('Failed to submit Express Interest form');
    }
  } catch (error) {
    console.error('Error submitting Express Interest form:', error);
  }
  

};
  return (
    <div> 
        <Header/>
        <div className=" bg-[#1E2A3A] flex justify-center py-14">
            <div className="bg-white p-6 rounded-lg lg:w-[50%] w-[100%]">
              <h2 className="text-xl font-bold mb-4">Express Interest Form</h2>
              <form onSubmit={handleExpressSubmit}>
                <label className="block mb-2">
                  Full Name:
                  <input type="text" className="w-full border p-2 rounded mt-1" name='fullName' required />
                </label>
                <label className="block mb-2">
                  Email:
                  <input type="email" className="w-full border p-2 rounded mt-1" name='email' required />
                </label>
                <label className="block mb-2">
                  DOB:
                  <input type="date" className="w-full border p-2 rounded mt-1" name='dob' required />
                </label>
                <label className="block mb-2">
                  Business / Organization Name:
                  <input type="text" className="w-full border p-2 rounded mt-1" name='businessName' required />
                </label>
                <label className="block mb-2">
                  Business Classification / Category:
                  <input type="text" className="w-full border p-2 rounded mt-1" name='category' required />
                </label>
                <label className="block mb-2">
                  Mobile No.:
                  <input type="tel" className="w-full border p-2 rounded mt-1" name='mobile' required />
                </label>
                <button
                  className="bg-[#02256D] rounded w-[110px] text-[#F1F4F9] font-[16px] h-[46px]"
                  type="submit"
                >
                  Submit
                </button>
               
              </form>
            </div>
          </div>
  <Footer/>
  </div>
  )
}

export default ExpressInterest